// ==============================|| MENU ITEMS - LOCATIONS ||============================== //

import { PERMISSIONS } from "../permissions/permissions";

const menuComponents = {
  id: 'menu',
  path:"/menu",
//   title: 'Forms',
  type: 'group',
  children: [
    {
      id: 'menu-elements',
      title: 'menu.menuMgnt',
      type: 'collapse',
      icon: 'ph ph-fork-knife',
      children: [
        {
          id: 'manage-menus',
          title: 'menu.manageMenu',
          type: 'item',
          url: '/menu/manage-menu',
          permission: PERMISSIONS.MENU_MANAGEMENT.VIEW
        },

        {
          id: 'category',
          title: 'menu.categories',
          type: 'item',
          url: '/menu/categories'
        },
        {
          id: 'foodItems',
          title: 'menu.foodItems',
          type: 'item',
          url: '/menu/FoodItems'
        }
      ]
    }
  ]
};

export default menuComponents;